/**
 * Keeps the Home cards at the 24px/24px/0 padding the deprecated FieldsetOld applied.
 * Targets the card because `className` on Fieldset lands on the outer wrapper.
 */
export const FIELDSET_CARD_PADDING = '[&>div]:px-6 [&>div]:pt-6 [&>div]:pb-0';
